import { useEffect, useState, Dispatch, SetStateAction } from 'react';
import { FaChevronLeft, FaPen, FaTrash } from 'react-icons/fa';
import { Container, CategoryBox, CategoryList } from './_Services';
import { Input } from '../../../../shared/components/Input/Input';
import correctIcon from '../../../../shared/icons/correctIcon.png';
import forkKnife from '../../../../shared/icons/forkKnife.png';
import { SuccessModal } from 'shared/components/SuccessModal/SuccessModal';
import { EditModal } from './components/EditModal/EditModal';
import { LoadingOutlined } from '@ant-design/icons';
import { Pagination } from 'antd';
import { toast } from 'react-toastify';
import api from '../../../../services/api';
import { useAuth } from '../../../../hooks/Auth';

import { useCategories } from '../../../../hooks/Categories';
import { getFormattedDate } from '../../../../utils/Validations';

interface ServicePorps {
  setActiveTab: Dispatch<SetStateAction<string>>;
}

interface Categories {
  id: string;
  name: string;
  created_at: string;
}

export const Services = ({ setActiveTab }: ServicePorps) => {
  const { data } = useAuth();
  const {
    pageServices,
    totalEstablishments,
    setCategoriesId,
    openEditModal,
    setOpenEditModal,
    insertCategoriesServices,
    deleteCategory,
    loadingBtn,
    loading,
    setPageServices,
    setTotalServices,
  } = useCategories();
  const [categoryname, setCategoryName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoriesServices, setCategoriesServices] = useState<Categories[]>(
    [],
  );
  async function getCategories() {
    try {
      const headers = { Authorization: `Bearer ${data.accessToken}` };
      const resEstablishments = await api.get(
        '/categories/establishments?limit=3',
        {
          headers,
        },
      );
      setCategoriesServices(resEstablishments.data.results);
      setPageServices(resEstablishments.data.page);
      setTotalServices(resEstablishments.data.total);
    } catch (error) {
      toast.error(error.response?.data?.message || error.toString());
    }
  }

  useEffect(() => {
    getCategories();
  }, [openEditModal, loading, loadingBtn]);

  async function handleChangePageEstablishments(page: number) {
    try {
      const headers = { Authorization: `Bearer ${data.accessToken}` };
      const resEstablishments = await api.get(
        `/categories/establishments?page=${page}&limit=3`,
        {
          headers,
        },
      );
      setCategoriesServices(resEstablishments.data.results);
    } catch (error) {
      toast.error(error.response?.data?.message || error.toString());
    }
  }

  function renderCategoryList() {
    return categoriesServices.map((category) => (
      <CategoryList key={category.id}>
        <img src={forkKnife} />
        <div>
          <h2>{category.name}</h2>
          <p>SERVIÇOS</p>
          <p>Data do Cadastro: {getFormattedDate(category.created_at)}</p>
        </div>
        {HandleCategoryActions(category.id)}
      </CategoryList>
    ));
  }

  function HandleCategoryActions(id: string) {
    return (
      <div key={id}>
        <FaTrash className="actionIcons" onClick={() => deleteCategory(id)} />
        <FaPen
          className="actionIcons"
          onClick={() => {
            setOpenEditModal(true);
            setCategoriesId(id);
          }}
        />
      </div>
    );
  }

  function handleInsertCategory() {
    if (categoryname.trim() === '') {
      toast.error('Digite o nome da categoria!');
      return;
    }

    insertCategoriesServices(categoryname);
    setCategoryName('');
  }

  return (
    <Container>
      <div
        onClick={() => {
          setActiveTab('');
        }}
      >
        <FaChevronLeft size={21} color="#21e270" />
        <h1>Categoria de Serviços</h1>
      </div>

      <CategoryBox>
        <div>
          <h1>Inserir Categoria</h1>

          <h5>Nome da categoria:</h5>
          <div>
            <Input
              value={categoryname}
              onChange={(e) => setCategoryName(e.target.value)}
              placeholder="Digite o nome..."
            />
            <button
              onClick={() => {
                handleInsertCategory();
              }}
            >
              {!loadingBtn ? (
                <img src={correctIcon} />
              ) : (
                <LoadingOutlined style={{ fontSize: 24, color: '#fff' }} spin />
              )}
            </button>
          </div>

          <h1>Categorias Cadastradas</h1>
          {renderCategoryList()}
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Pagination
              defaultCurrent={pageServices}
              total={40}
              onChange={(e) => handleChangePageEstablishments(e)}
            />
          </span>
        </div>
      </CategoryBox>
      <EditModal
        openEditModal={openEditModal}
        setOpenEditModal={setOpenEditModal}
      />
      <SuccessModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        text="Alterações salvas com sucesso!"
      />
    </Container>
  );
};
